/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bad_Major_Porpoise_ScoldInputs */

const fr_bad_major_porpoise_scold = /** @type {(inputs: Bad_Major_Porpoise_ScoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer par packs`)
};

/**

* @param {Bad_Major_Porpoise_ScoldInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bad_major_porpoise_scold = /** @type {((inputs?: Bad_Major_Porpoise_ScoldInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bad_Major_Porpoise_ScoldInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bad_major_porpoise_scold(inputs)
});